import { t } from '@lingui/core/macro';
import {
    CustomPartCategoryDetailsType,
    CustomPartSpecificationLiteDto,
    PartLite,
    PartLiteTypes,
} from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

export function formatPartLite(part?: PartLite | null | undefined): string {
    if (!isPresent(part)) {
        return '-';
    }
    switch (part.kind) {
        case PartLiteTypes.OffTheShelf:
            return `${part.mpn}, ${part.manufacturer.name}`;
        case PartLiteTypes.Generic:
            return t`Generic ${part.content.type}`;
        case PartLiteTypes.Unknown:
            if (part.mpn && part.manufacturer.name) {
                return t`Unknown ${part.mpn}, ${part.manufacturer.name}`;
            }
            return t`Unknown`;
        case PartLiteTypes.RawSpecification:
            if (isPresent(part.manufacturer.name) && isPresent(part.mpn)) {
                return `${part.mpn}, ${part.manufacturer.name}`;
            }
            if (isPresent(part.mpn)) {
                return `${part.mpn}`;
            }
            if (isPresent(part.manufacturer.name)) {
                return `${part.manufacturer.name}`;
            }
            return t`Unknown`;
        case PartLiteTypes.Ipn:
            return part.id;
        case PartLiteTypes.Custom:
            return formatCustomPartLite(part);
        case PartLiteTypes.CustomComponent:
            return part.id;
    }
}

function formatCustomPartLite(part: CustomPartSpecificationLiteDto): string {
    const detail = part.drawing_number
        ? t`Drawing: ${part.drawing_number}${part.revision ? ` • ${part.revision}` : ''}`
        : `${part.category.category} ${part.description ?? ''}`;

    if (part.category_details.type === CustomPartCategoryDetailsType.PCB) {
        return `PCB ${detail}`;
    }

    return `Custom ${detail}`;
}
